/**
 * 默认参数设置
 * @param config.baseUrl 服务器配置-服务器地址
 * @param config.requestKey 服务器配置-加密key
 * @param data.ve ve值
 * @param data.clientType 请求的客户端类型
 * @param data.ms 时间戳
 */
export default {
  config: {
    baseUrl: 'https://www.szkljy.com/pm/data?',
    requestKey: 'D3029C73406221B02026B684BB00579C',
  },
  data: {
    ve: 1,
    clientType: 'html',
    ms: new Date().getTime(),
  },
};
